import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import contentData from "./i18n-content.json";

export const content = contentData;

const LanguageContext = createContext(null);

const META = contentData.meta;

const langFromPath = (pathname) => (pathname === "/en" || pathname.startsWith("/en/") ? "en" : "fr");

export const LanguageProvider = ({ children }) => {
  const { pathname } = useLocation();
  const [lang, setLang] = useState(() => langFromPath(window.location.pathname));
  useEffect(() => {
    setLang(langFromPath(pathname));
  }, [pathname]);
  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
    document.title = META[lang].title;
    document.querySelector('meta[name="description"]')?.setAttribute("content", META[lang].description);
  }, [lang]);
  return (
    <LanguageContext.Provider value={{ lang, setLang, t: content[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useI18n = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useI18n must be used within LanguageProvider");
  return ctx;
};
